module.exports = __webpack_public_path__ + "img/row-grey-small.d327d23e.svg";